/**
 * /aim/call query_state 响应解析：submit 与 poll 分支共用
 */

export function pickFirstNonEmpty(obj, keys) {
  if (!obj || typeof obj !== 'object') return ''
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i]
    if (obj[key] != null && String(obj[key]).trim() !== '') return String(obj[key]).trim()
  }
  return ''
}

export function extractCreateId(data) {
  if (!data || typeof data !== 'object') return ''
  return pickFirstNonEmpty(data, ['create_id', 'createId'])
}

export function extractTaskId(data) {
  if (!data || typeof data !== 'object') return ''
  var top = pickFirstNonEmpty(data, ['taskId', 'task_id', 'id'])
  if (top) return top
  if (data.data && typeof data.data === 'object') {
    var nested = pickFirstNonEmpty(data.data, ['taskId', 'task_id', 'id'])
    if (nested) return nested
    if (data.data.data && typeof data.data.data === 'object') {
      return pickFirstNonEmpty(data.data.data, ['taskId', 'task_id', 'id'])
    }
  }
  return ''
}

export function extractData(payload) {
  if (!payload || typeof payload !== 'object') return {}
  if (payload.data && typeof payload.data === 'object') {
    return payload.data
  }
  /* 部分接口：{ code, result: { data: { generations } } } */
  if (payload.result && typeof payload.result === 'object') {
    if (payload.result.data && typeof payload.result.data === 'object') {
      return payload.result.data
    }
    return payload.result
  }
  return {}
}

export function extractStatus(data) {
  var nodes = []
  if (data && typeof data === 'object') {
    nodes.push(data)
    if (data.data && typeof data.data === 'object') {
      nodes.push(data.data)
      if (data.data.data && typeof data.data.data === 'object') nodes.push(data.data.data)
    }
  }
  var raw = ''
  for (var i = 0; i < nodes.length; i++) {
    var node = nodes[i]
    raw = pickFirstNonEmpty(node, ['status', 'task_status', 'state', 'code'])
    if (!raw && Array.isArray(node.generations) && node.generations.length > 0) {
      raw = pickFirstNonEmpty(node.generations[0], ['status', 'task_status', 'state', 'code'])
    }
    if (raw) break
  }
  if (!raw && data && typeof data === 'object' && Array.isArray(data.generations) && data.generations.length > 0) {
    raw = pickFirstNonEmpty(data.generations[0], ['status', 'task_status', 'state', 'code'])
  }
  var upper = String(raw || '').toUpperCase()
  if (upper === 'SUCCEEDED' || upper === 'SUCCESS' || upper === 'COMPLETED' || upper === 'DONE' || upper === 'SUCCEED') return 'completed'
  if (upper === 'FAILED' || upper === 'FAILURE' || upper === 'CANCELED' || upper === 'CANCELLED' || upper === 'ERROR') return 'failed'
  /* 兜底：raw 为数字型错误码（如 "500"）时视为失败，服务器后续会统一格式，此处仅做一次校验 */
  var rawNum = Number(raw)
  if (raw && !isNaN(rawNum) && rawNum !== 200 && rawNum !== 220 && rawNum !== 0) {
    return 'failed'
  }
  return 'processing'
}

function collectMediaBuckets(data) {
  var buckets = []
  if (!(data && typeof data === 'object')) return buckets
  buckets.push(data)
  if (data.data && typeof data.data === 'object') {
    buckets.push(data.data)
    if (data.data.data && typeof data.data.data === 'object') buckets.push(data.data.data)
  }
  for (var i = 0; i < buckets.length; i++) {
    var b = buckets[i]
    if (Array.isArray(b.generations)) {
      for (var j = 0; j < b.generations.length; j++) {
        if (b.generations[j] && typeof b.generations[j] === 'object') buckets.push(b.generations[j])
      }
    }
  }
  return buckets
}

export function extractMedia(data) {
  var buckets = collectMediaBuckets(data)
  if (data && typeof data === 'object') {
    if (data.output && typeof data.output === 'object') buckets.push(data.output)
    if (data.result && typeof data.result === 'object') buckets.push(data.result)
  }
  for (var i = 0; i < buckets.length; i++) {
    var b = buckets[i]
    var url = pickFirstNonEmpty(b, ['url', 'video_url', 'videoUrl', 'resultUrl', 'download_url', 'downloadUrl'])
    if (url) return { url: url, base64: '' }
    var base64 = pickFirstNonEmpty(b, ['base64', 'video_base64', 'videoBase64', 'resultBase64', 'content'])
    if (base64) return { url: '', base64: base64 }
  }
  return { url: '', base64: '' }
}

export function toDataMediaUrl(base64Raw, modelType) {
  var s = String(base64Raw || '').trim()
  if (!s) return ''
  if (s.indexOf('data:') === 0) return s
  var mime = modelType === 'image' ? 'image/png' : 'video/mp4'
  return 'data:' + mime + ';base64,' + s
}

export function shouldKeepPollingEmptyImagesPayload(stateData) {
  if (!stateData || typeof stateData !== 'object') return false
  var buckets = []
  buckets.push(stateData)
  if (stateData.data && typeof stateData.data === 'object') {
    buckets.push(stateData.data)
    if (stateData.data.data && typeof stateData.data.data === 'object') buckets.push(stateData.data.data)
  }
  for (var i = 0; i < buckets.length; i++) {
    var b = buckets[i]
    if (b && typeof b === 'object' && Array.isArray(b.images) && b.images.length === 0) {
      return true
    }
  }
  return false
}

function extractPollingUrlNested(data) {
  if (!data || typeof data !== 'object') return ''
  var buckets = [data]
  if (data.data && typeof data.data === 'object') {
    buckets.push(data.data)
    if (data.data.data && typeof data.data.data === 'object') buckets.push(data.data.data)
  }
  for (var i = 0; i < buckets.length; i++) {
    var u = pickFirstNonEmpty(buckets[i], ['pollingUrl', 'polling_url'])
    if (u) return u
  }
  return ''
}

export function extractPollingUrlFromPollResponse(stateRes) {
  if (!stateRes || typeof stateRes !== 'object') return ''
  var top = pickFirstNonEmpty(stateRes, ['pollingUrl', 'polling_url'])
  if (top) return top
  var u = extractPollingUrlNested(extractData(stateRes))
  if (u) return u
  if (stateRes.data && typeof stateRes.data === 'object') {
    u = extractPollingUrlNested(stateRes.data)
    if (u) return u
  }
  return ''
}

export function extractImageUrls(data) {
  var urls = []
  var buckets = []
  if (data && typeof data === 'object') {
    buckets.push(data)
    if (data.data && typeof data.data === 'object') {
      buckets.push(data.data)
      if (data.data.data && typeof data.data.data === 'object') buckets.push(data.data.data)
    }
  }
  for (var i = 0; i < buckets.length; i++) {
    var b = buckets[i]
    var direct = pickFirstNonEmpty(b, ['url', 'image_url', 'imageUrl', 'resultUrl', 'download_url', 'downloadUrl'])
    if (direct) urls.push(direct)
    var list = b.images || b.results || b.outputs || b.data
    if (Array.isArray(list)) {
      for (var j = 0; j < list.length; j++) {
        var item = list[j]
        if (!item || typeof item !== 'object') continue
        var u = pickFirstNonEmpty(item, ['url', 'image_url', 'imageUrl', 'resultUrl', 'download_url', 'downloadUrl'])
        if (u) urls.push(u)
      }
    }
  }
  var dedup = []
  for (var k = 0; k < urls.length; k++) {
    if (dedup.indexOf(urls[k]) === -1) dedup.push(urls[k])
  }
  return dedup
}

export function findMidjourneyGenerations(stateData) {
  if (!stateData || typeof stateData !== 'object') return null
  var g = stateData.generations
  if (Array.isArray(g) && g.length) return g
  if (stateData.data && typeof stateData.data === 'object') {
    g = stateData.data.generations
    if (Array.isArray(g) && g.length) return g
    if (stateData.data.data && typeof stateData.data.data === 'object') {
      g = stateData.data.data.generations
      if (Array.isArray(g) && g.length) return g
    }
  }
  return null
}

export function parseMidjourneyImagePoll(stateData) {
  var gens = findMidjourneyGenerations(stateData)
  if (!gens || !gens.length) return null
  var g0 = gens[0]
  if (!g0 || typeof g0 !== 'object') return null
  var st = String(g0.status || '').trim().toLowerCase()
  var url = pickFirstNonEmpty(g0, ['url', 'audio_url', 'audioUrl', 'download_url', 'downloadUrl'])
  var fileIdGen = pickFirstNonEmpty(g0, ['fileId', 'file_id'])
  var failReason = pickFirstNonEmpty(g0, ['failReason', 'error', 'message'])
  if (st === 'failed' || st === 'failure' || st === 'error' || st === 'canceled' || st === 'cancelled') {
    return { kind: 'failed', error: failReason || '生成失败' }
  }
  var wait =
    st === 'processing' ||
    st === 'pending' ||
    st === 'waiting' ||
    st === 'in_progress' ||
    st === 'queued' ||
    st === 'starting' ||
    st === ''
  if (wait && !url) {
    return { kind: 'wait' }
  }
  var done =
    st === 'completed' ||
    st === 'complete' ||
    st === 'success' ||
    st === 'succeeded' ||
    st === 'succeed' ||
    st === 'done'
  if (done && url) {
    return { kind: 'done', url: url }
  }
  /* Sora 等：条目标记已成功但 url 仍空，需再走 download_video（Hailuo 特例见 poll-video） */
  if (done && !url) {
    return { kind: 'need_download', fileId: fileIdGen }
  }
  if (url) {
    return { kind: 'done', url: url }
  }
  if (wait) {
    return { kind: 'wait' }
  }
  return { kind: 'wait' }
}
